import React from 'react';
import { selectCssVariables, cssVariables } from '../../../redux/cssVariablesSlice';
import {
	Flex,
	Box,
	AccordionButton,
	AccordionItem,
	AccordionIcon,
	AccordionPanel,
	Text,
	FormLabel,
	Select,
	Input,
} from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
//import types from selectablecssvariablesdropdown
import { types } from '../SelectableCssVariables/SelectableCssVariablesDropdown';

const globalInputs = [
	'--global-container-size-big',
	'--global-container-size-small',
	'--global-desktop-padding',
	'--global-mobile-padding',
];
const globalDropdowns = [
	{ type: 'borderRadius', key: '--global-login-border-radius' },
	{ type: 'borderRadius', key: '--global-border-radius' },
	{ type: 'borderRadius', key: '--global-orders-border-radius' },
	//global login button fontsize
	{ type: 'fontSize', key: '--global-login-button-fs' },
	//global login button fontweight
	{ type: 'fontWeight', key: '--global-login-button-fw' },
	//global login button fontfamily
	{ type: 'typography', key: '--global-login-button-ff' },
	//global login title fontsize
	{ type: 'fontSize', key: '--global-login-title-fs' },
	//global login title fontweight
	{ type: 'fontWeight', key: '--global-login-title-fw' },
	//global login title fontfamily
	{ type: 'typography', key: '--global-login-title-ff' },
];
const labels = {
	'--global-container-size-big': 'Largura Max. Tela maiores que 1400px',
	'--global-container-size-small': 'Largura Max. Tela menores que 1400px',
	'--global-desktop-padding': 'Padding lateral Desktop (maior que 1536px)',
	'--global-mobile-padding': 'Padding lateral Mobile (até 1536px)',
	'--global-login-border-radius': 'Raio borda Login',
	'--global-border-radius': 'Raio borda componentes nativos Vtex',
	'--global-orders-border-radius': 'Raio borda Orders',
	'--global-login-button-fs': 'Tamanho fonte botão Login',
	'--global-login-button-fw': 'Peso fonte botão Login',
	'--global-login-button-ff': 'Família fonte botão Login',
	'--global-login-title-fs': 'Tamanho fonte título Login',
	'--global-login-title-fw': 'Peso fonte título Login',
	'--global-login-title-ff': 'Família fonte título Login',
};
const defaultValues = {
	'--global-container-size-big': '1536',
	'--global-container-size-small': '1536',
	'--global-desktop-padding': '16',
	'--global-mobile-padding': '8',
	'--global-login-border-radius': '--border-radius-lg',
	'--global-border-radius': '--border-radius-sm',
	'--global-orders-border-radius': '--border-radius-none',
	'--global-login-button-fs': '--font-size-sm',
	'--global-login-button-fw': '--font-weight-400',
	'--global-login-button-ff': '--main-font',
	'--global-login-title-fs': '--font-size-md',
	'--global-login-title-fw': '--font-weight-400',
	'--global-login-title-ff': '--main-font',
};

const CssEditorGlobalVarSelector = () => {
	const [inputStates, setInputStates] = React.useState({});
	const cssVar = useSelector(cssVariables);
	const dispatch = useDispatch();

	function updateValue(evt, key) {
		const value = evt.target.value;
		const newCssGlobalVar = { ...cssVar };
		if (globalInputs.find((value) => value === key)) {
			newCssGlobalVar[key] = (value ? Number(value / 16).toFixed(2) : 0) + 'rem';
		}
		//check if key exists in one of the objects of globalDropdowns
		const dropdown = globalDropdowns.find(({ key: dropdownKey }) => dropdownKey === key);
		if (dropdown) {
			newCssGlobalVar[key] = `var(${evt.target.value})`;
		}
		dispatch(selectCssVariables(newCssGlobalVar));
	}

	function updateState(evt, key) {
		const value = evt.target.value;
		setInputStates({
			...inputStates,
			[key]: value,
		});
	}

	function getValue(option) {
		const val = cssVar[option.value];
		return val ? ` - ${val}` : '';
	}

	React.useEffect(() => {
		//if input state is an empty object
		if (cssVar && Object.keys(inputStates).length === 0) {
			const newInputStates = { ...inputStates };
			globalInputs.forEach((key) => {
				newInputStates[key] = cssVar[key] ? Number(cssVar[key].replace('rem', '') * 16) : defaultValues[key];
			});
			globalDropdowns.forEach(({ key }) => {
				newInputStates[key] = cssVar[key] ? cssVar[key].replace('var(', '').replace(')', '') : defaultValues[key];
			});
			setInputStates(newInputStates);
		}
	}, [cssVar, inputStates]);

	if (!cssVar) return null;

	return (
		<AccordionItem>
			<AccordionButton justifyContent={'space-between'}>
				<Text>Globais</Text>
				<AccordionIcon />
			</AccordionButton>
			<AccordionPanel>
				<Box p={2} overflow={'visible'}>
					<Flex flexDir="row" flexWrap={'wrap'} sx={{ gap: '1px' }} overflow={'auto'} justifyContent={'space-between'}>
						{globalInputs.map((key, index) => (
							<Box w={'100%'} key={`globalInputs-${key}-${index}`}>
								<FormLabel
									mr={0}
									borderColor={'gray.200'}
									fontFamily={'Poppins'}
									color={'gray.700'}
									fontWeight="bold"
									fontSize={'sm'}
								>
									{labels[key]}
								</FormLabel>
								<Input
									type={'tel'}
									onChange={(e) => updateState(e, key)}
									onBlur={(e) => updateValue(e, key)}
									borderRadius={'8px'}
									value={inputStates[key]}
									defaultValue={cssVar[key] ? cssVar[key].replace('rem', '') : inputStates[key]}
									size={'sm'}
									w={'100px'}
								/>
								<Text ml={1} display={'inline'}>
									px
								</Text>
							</Box>
						))}
						{globalDropdowns.map(({ key, type }) => (
							<Box w={'100%'} key={`globalDropdowns-${type}-${key}`}>
								<FormLabel
									mr={0}
									borderColor={'gray.200'}
									fontFamily={'Poppins'}
									color={'gray.700'}
									fontWeight="bold"
									fontSize={'sm'}
								>
									{labels[key]}
								</FormLabel>
								<Select
									size={'sm'}
									value={inputStates[key]}
									defaultValue={cssVar[key] ? cssVar[key].replace('var(', '').replace(')', '') : inputStates[key]}
									onChange={(e) => {
										updateState(e, key);
										updateValue(e, key);
									}}
								>
									{types[type].map((option, index) => {
										return (
											<option key={`${key}-${type}-${index}`} value={option.value}>
												{option.name}
												{getValue(option)}
											</option>
										);
									})}
								</Select>
							</Box>
						))}
					</Flex>
				</Box>
			</AccordionPanel>
		</AccordionItem>
	);
};

export default CssEditorGlobalVarSelector;
